function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1704.000000, -551.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1704.000000, 551.000000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.2,
  fillRule: "evenodd",
  className: "primary-stroke primary-fill"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.5,0.371621622 C18.0466892,0.371621622 9.41540541,3.21683108 4.41560811,7.98391892 C1.7707027,10.5068581 0.371324324,13.3985946 0.371324324,16.3513514 C0.371324324,18.2472162 0.934561486,20.1024257 2.04941892,21.8618311 C2.90006081,23.2205541 4.06427703,24.5009392 5.51010811,25.6709527 C5.63785676,25.775475 5.72785608,25.9177318 5.76559797,26.0774176 C5.875925,26.5506554 5.93398716,27.0326338 5.93398716,27.5116541 C5.93398716,29.2159108 5.26332905,30.7982014 4.0903723,31.9653162 C5.05428446,32.2091966 6.05008176,32.3311487 7.06044662,32.3311487 C9.42373716,32.3311487 11.7115142,31.6575689 13.6799196,30.3830182 C13.8018561,30.3046284 13.9412142,30.2639804 14.0834784,30.2639804 C14.1618682,30.2639804 14.2402581,30.2755936 14.3157419,30.301723 C18.3280662,31.6285609 22.8860797,32.3311487 27.4993905,32.3311487 C42.4571608,32.3311487 54.6277689,25.1629393 54.6277689,16.351419 C54.6277689,7.53989872 42.4571608,0.371621622 27.4993905,0.371621622 L27.5,0.371621622 Z",
  fillRule: "nonzero"
})))));

const SvgIcBubble = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "33px",
    viewBox: "0 0 55 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBubble, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-bubble.9e3427ec.svg";
export { ForwardRef as ReactComponent };